export default "__VITE_ASSET__tLfnBUzd__"